import React from "react";
import { RiFireFill } from "react-icons/ri";
import NormalButton from "./NormalButton";

const Waitlist = () => {
  return (
    <div className="open-engine-waitlist-container">
      <p className="desc">No More Limits.</p>
      <p className="desc">No More Downtime.</p>
      <p className="heading">
        Just Open<span>Engine.</span>
      </p>
      <NormalButton title={"Deploy on Cloud"} />
      <p className="footer">
        <RiFireFill /> <span>Hurry ! Limited Access Only</span>
      </p>
    </div>
  );
};

export default Waitlist;
